<template>
    <input
        name="order"
        type="radio"
        :checked="isSelected"
        class="hidden"
    />
    <span class="radio-with-check">
      <span class="radio-empty">&nbsp;</span>
      <span class="radio-check">&#x2713;</span>
    </span>
</template>

<script>
export default {
  name: 'InputCheckRadio',
  props: {
    currentOrder: String,
    order: String,
  },
  computed: {
    isSelected() {
      return this.currentOrder === this.order;
    },
  },
  methods: {
    updateOrder(order) {
      this.$emit('updateOrder', order);
    },
  },
};
</script>
